import { createTheme } from '@mui/material/styles'
import { colors } from './colors'

export const baseTheme = createTheme({
  palette: {
    common: {
      black: colors.black,
      white: colors.resiliaWhite,
    },
    primary: {
      main: colors.resiliaBlue,
      dark: colors.navy,
      contrastText: colors.resiliaWhite,
      light: colors.lightestGrey,
    },
    secondary: {
      main: colors.resiliaGreen,
      dark: colors.green,
    },
    error: {
      main: colors.red,
      light: colors.coral,
    },
    warning: {
      main: colors.yellow,
      light: colors.lightYellow,
    },
    info: {
      main: colors.blue,
      light: colors.lightBlue,
      dark: colors.darkBlue,
    },
    text: {
      primary: colors.black,
      secondary: colors.darkGrey,
    },
    background: {
      default: colors.backgroundGrey,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          textTransform: 'none',
          fontSize: 14,
          borderRadius: 4,
          color: colors.resiliaBlue,
          fontFamily: '"Source Sans Pro", sans-serif',
        },
        contained: {
          color: colors.resiliaWhite,
        },
        outlined: {
          border: `2px solid ${colors.resiliaBlue}`,
        },
        outlinedPrimary: {
          border: `2px solid ${colors.resiliaBlue} !important`,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&$selected': {
            backgroundColor: colors.navy,
            borderLeft: `8px solid ${colors.green}`,
            paddingLeft: '8px',
          },
        },
        gutters: {
          paddingRight: '5px',
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontWeight: 700,
          color: colors.darkGrey,
          '&$active': {
            fontWeight: 700,
            color: colors.darkGrey,
          },
          '&$completed': {
            fontWeight: 700,
            color: colors.darkGrey,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          backgroundColor: colors.resiliaWhite,
          paddingLeft: 2,
          paddingRight: 2,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: colors.black,
          backgroundColor: colors.resiliaWhite,
          border: `1px solid ${colors.lightBlue}`,
          padding: '10px',
          fontSize: 14,
          boxShadow: '2px 4px 8px rgba(0, 50, 99, 0.07)',
          fontFamily: '"Source Sans Pro", sans-serif',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          backgroundColor: colors.lightestBlue,
          minWidth: '40px',
          marginRight: '10px',
          border: `1px solid ${colors.lightBlue}`,
        },
        root: {
          fontFamily: '"Source Sans Pro", sans-serif',
        },
        deletable: {
          backgroundColor: colors.lightestBlue,
          minWidth: '40px',
          marginRight: '10px',
          border: `1px solid ${colors.lightBlue}`,
        },
        deleteIcon: {
          color: colors.resiliaBlue,
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          fontFamily: 'Source Sans Pro',
          fontSize: 13,
          fontWeight: 700,
          lineHeight: '21px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& input[type=number]': {
            '-moz-appearance': 'textfield',
          },
          '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
          },
          '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          main: {
            overflowX: 'hidden',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
        h1: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '48px',
          lineHeight: '115%',
        },
        h2: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '40px',
          lineHeight: '125%',
        },
        h3: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '32px',
          lineHeight: '125%',
        },
        h4: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '24px',
          lineHeight: '135%',
        },
        h5: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '20px',
          lineHeight: '135%',
        },
        h6: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '16px',
          lineHeight: '135%',
        },
        body1: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '14px',
          lineHeight: '165%',
        },
        body2: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '12.8px',
          lineHeight: '165%',
        },
        subtitle1: {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '20px',
          lineHeight: '135%',
          fontWeight: 600,
        },
        button: {
          fontFamily: '"Source Sans Pro", sans-serif',
        },
      },
    },
  },
})
